import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const partsApi = createApi({
  reducerPath: "partsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BACKEND_URL}/api/parts`,
  }),
  endpoints: (builder) => ({
    addPartReview: builder.mutation<
      { message: string },
      {
        id: string;
        review: {
          message: string;
          rating: number;
        };
      }
    >({
      query: ({ id, review }) => ({
        url: `/${id}/reviews`,
        method: "POST",
        body: review,
      }),
    }),
  }),
});

export const { useAddPartReviewMutation } = partsApi;
